import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, api } from "@/lib/api";

const AuthCtx = createContext(null);

async function fetchMe() {
  try {
    return (await api.get("/auth/me")).data;
  } catch (e) {
    if (e.response?.status !== 401) return false;
    try {
      await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
      return (await api.get("/auth/me")).data;
    } catch {
      return false;
    }
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => setUser(await fetchMe()), []);

  useEffect(() => {
    // Il callback Google gestisce la sessione prima del controllo /me
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
